import React from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import Main from './layouts/Main'
import IslamicLayout from './layouts/IslamicLayout'
import NotFound from "./pages/NotFound"
import ProtectedRoute from "./components/ProtectedRoute"
import { getToken } from "./services/authorize"
import { AuthProvider, useAuth } from "./services/authProvider"
import { LoadingProvider, useLoading } from "./contexts/LoadingContext"
import Loading from "./components/Loading"

import publicRoutes from "./routes/PublicRoutes"
import protectedRoutes, { islamicProtectedRoutes } from "./routes/ProtectedRoutes"

// import TeacherSelfUpdate from "./pages/TeacherSelfUpdate" // ปิดชั่วคราว

import "remixicon/fonts/remixicon.css"
import "./scss/style.scss"

window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode")
  let HTMLTag = document.querySelector("html")

  if (skinMode) {
    HTMLTag.setAttribute("data-skin", skinMode)
  }
});

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }
  static getDerivedStateFromError() {
    return { hasError: true }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', fontFamily: 'sans-serif' }}>
          <p style={{ fontSize: '1.2rem', color: '#555' }}>เกิดข้อผิดพลาด กรุณารีเฟรชหน้าเว็บ</p>
          <button onClick={() => window.location.reload()} style={{ padding: '8px 20px', cursor: 'pointer' }}>รีเฟรช</button>
        </div>
      )
    }
    return this.props.children
  }
}

function getAuthenticatedLandingPath(posIds = []) {
  const positions = posIds.map(Number);
  if (positions.includes(90)) return "/executive/dashboard";
  return "/dashboard/school-statistic";
}

// ✅ สร้าง AppWrapper แยก เพื่อให้ใช้ useLoading ได้ภายใน Provider
function AppWrapper() {
  const { loading } = useLoading();
  const { posIds = [], isLoading: authLoading } = useAuth() || {};
  const landingPath = getAuthenticatedLandingPath(posIds);
  const authenticatedRedirect = getToken()
    ? (authLoading ? <Loading /> : <Navigate to={landingPath} replace />)
    : <Navigate to="/pages/signin" replace />;

  return (
    <>
      {loading && <Loading />}
      <BrowserRouter>
        <Routes>
          {/* Add root path redirect */}
          <Route
            path="/"
            element={authenticatedRedirect}
          />

          {/* Protected routes */}
          <Route path="/" element={<ProtectedRoute component={Main} />}>
            {protectedRoutes.map((route, index) => (
              <Route
                path={route.path}
                element={
                  <ProtectedRoute
                    component={route.element.type}
                    requiredPositions={route.requiredPositions}
                  />
                }
                key={index}
              />
            ))}
          </Route>

          {/* Islamic Education routes (RTL layout) */}
          <Route path="/" element={<ProtectedRoute component={IslamicLayout} />}>
            {islamicProtectedRoutes.map((route, index) => (
              <Route
                path={route.path}
                element={
                  <ProtectedRoute
                    component={route.element.type}
                    requiredPositions={route.requiredPositions}
                  />
                }
                key={`islamic-${index}`}
              />
            ))}
          </Route>

          {/* Public teacher self-service profile update (no login) — ปิดชั่วคราว */}
          {/* <Route path="/teacher-update" element={<TeacherSelfUpdate />} /> */}

          {/* Public routes with signin redirect */}
          {publicRoutes.map((route, index) => {
            if (route.path === 'pages/signin') {
              return (
                <Route
                  path={route.path}
                  element={getToken() ? (authLoading ? <Loading /> : <Navigate to={landingPath} replace />) : route.element}
                  key={index}
                />
              );
            }
            return (
              <Route path={route.path} element={route.element} key={index} />
            );
          })}

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <LoadingProvider>
          <AppWrapper />
        </LoadingProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}